import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import { combineProps, styled, useThemeProps, } from '../../../foundation';
import { RcTextField } from '../TextField';
import { TextareaStyle } from './styles';
import { RcTextareaInputClasses } from './utils';
var _RcTextarea = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcTextarea' });
    var classes = props.classes, InputPropsProp = props.InputProps, rowsProp = props.rows, minRows = props.minRows, maxRows = props.maxRows, rest = __rest(props, ["classes", "InputProps", "rows", "minRows", "maxRows"]);
    var InputProps = useMemo(function () {
        return combineProps({
            classes: RcTextareaInputClasses,
        }, InputPropsProp);
    }, [InputPropsProp]);
    var rows = rowsProp;
    // when have minRows and maxRows, not set rows to Mui
    if (minRows || maxRows) {
        rows = undefined;
    }
    return (React.createElement(RcTextField, __assign({}, rest, { rows: rows, minRows: minRows, maxRows: maxRows, multiline: true, InputProps: InputProps, clearBtn: false, ref: ref })));
});
/** @release */
var RcTextarea = styled(_RcTextarea)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), TextareaStyle);
RcTextarea.defaultProps = {
    rows: 3,
};
RcTextarea.displayName = 'RcTextarea';
export { RcTextarea };
var templateObject_1;
